import { css } from '@eti/styles';
import { useSiteContext, useTranslation } from '@eti/providers';
import { Inline, vars } from '@etg/wings';
import type { Dispatch, SetStateAction } from 'react';
import type { TripType } from '../../../models';
import ResultTripCard from './ResultTripCard';
import { RESULT_TRIPS } from './constants';

const selectedTripCardWrapperStyles = css`
  background: ${vars.colors.card.highlight.background};
  border-radius: ${vars.card.borderRadius};
  padding: 2px;
`;

const inlineStyles = css`
  color: ${vars.colors.card.highlight.foreground};
  font-size: 0.875rem;
  font-weight: 700;
  padding: 8px 14px;
`;

const resultTripCardStyles = css`
  border-radius: calc(${vars.card.borderRadius} - 2px);
`;

interface SelectedTripCardProps {
  trip: NonNullable<TripType>;
  setIsSelfTransferModalOpen: Dispatch<SetStateAction<boolean>>;
}

export const SelectedTripCard = ({ trip, setIsSelfTransferModalOpen }: SelectedTripCardProps) => {
  const { partner } = useSiteContext();
  const { t } = useTranslation();
  const selectedtripTitle =
    t(`Result.SelectedTrip.PartnerName.${partner}`) || t('Result.SelectedTrip.NoPartner.Heading');

  return (
    <div className={selectedTripCardWrapperStyles} data-testid="resultPage-selectedTrip-wrapper">
      <Inline className={inlineStyles}>{selectedtripTitle}</Inline>
      <ResultTripCard
        customStyles={resultTripCardStyles}
        resultTripType={RESULT_TRIPS.SELECTED}
        setIsSelfTransferModalOpen={setIsSelfTransferModalOpen}
        trip={trip}
      />
    </div>
  );
};
